// NavigationTabs.tsx
import React from 'react';
import { useLocation, useSearch } from 'wouter';
import styles from './NavigationTabs.module.css';
import BetaBadge from '@/components/BetaBadge/BetaBadge';
import Flex from '@/components/Flex/Flex';

// Define types for tab items
export interface TabItem {
  id: string;
  label: string;
  href: string;
  isActive?: boolean;
  isBeta?: boolean;
}

// Props interface for the component
interface NavigationTabsProps {
  tabs?: TabItem[];
}

/**
 * NavigationTabs component that takes tabs as a prop and uses Wouter's useLocation for navigation
 * @param {TabItem[]} tabs - Array of tab objects with id, label, and href properties
 */
const NavigationTabs: React.FC<NavigationTabsProps> = ({ 
  tabs = []
}) => {
  const [location, navigate] = useLocation();
  return (
    <div className={styles.container}>
      <div className={styles.tabsWrapper}>
        {tabs.map((tab) => {
          const isActive = tab.isActive !== undefined ? tab.isActive : location === tab.href;
          return (
            <button
              key={tab.id}
              onClick={() => navigate(tab.href)}
              className={`${styles.tab} ${isActive ? styles.activeTab : ''}`}
            >
              <Flex align="center" gap={2.5}>
                <span className={styles.tabLabel}>{tab.label}</span>
                {tab.isBeta && isActive && (
                  <BetaBadge className={styles.tabBetaBadge} />
                  )}
              </Flex>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default NavigationTabs;